import { colors } from './index';

/**
 * Get the display color for a confidence score.
 * Pure function — exported for direct use and testing.
 *
 * @param {number|null|undefined} score - 0-100 confidence score
 * @returns {string} hex color
 */
export function getConfidenceColor(score) {
  if (score == null || score === 0) return colors.textMuted;
  if (score >= 75) return colors.green;
  if (score >= 50) return colors.yellow;
  return colors.red;
}

const LABELS = { high: 'High', medium: 'Medium', low: 'Low' };

function getLabel(score) {
  if (score == null || score === 0) return '';
  if (score >= 75) return LABELS.high;
  if (score >= 50) return LABELS.medium;
  return LABELS.low;
}

/**
 * ConfidenceBadge — visual indicator for repair confidence scores.
 *
 * @param {number|null} score - 0-100
 * @param {'sm'|'md'|'lg'} size - sm: dot only, md: dot + label, lg: dot + score + label
 */
const ConfidenceBadge = ({ score, size = 'md' }) => {
  const color = getConfidenceColor(score);
  const label = getLabel(score);

  if (size === 'sm') {
    return (
      <span
        style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }}
      />
    );
  }

  if (size === 'md') {
    return (
      <span className="inline-flex items-center gap-1.5">
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
        {label && <span className="text-xs" style={{ color }}>{label}</span>}
      </span>
    );
  }

  // lg
  return (
    <span className="inline-flex items-center gap-1.5">
      <span style={{ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
      {score != null && score > 0 && (
        <span className="text-sm font-semibold" style={{ color }}>{score}</span>
      )}
      {label && <span className="text-xs" style={{ color: colors.textSecondary }}>{label}</span>}
    </span>
  );
};

export default ConfidenceBadge;
